import React from "react";
import { useNavigate } from "react-router-dom";
import { Typography, Icon, ButtonMenu, Button } from "@ann/web-components";
import { HeaderContainer, TitleContainer, HeaderWrapper,  IconWrapper } from "./Header.styled";

const Header = ({ title, subtitle, onAssignClick }) => {
  const navigate = useNavigate();

  const handleBackClick = () => {
    navigate("/v2/user-management/roles");
  };

  return (
    <HeaderContainer>
      <HeaderWrapper>
        <TitleContainer>
          <IconWrapper onClick={handleBackClick}>
            <Icon name="arrowLeft" size="medium" />
          </IconWrapper>
          {title && (
            <Typography category="title" size="large" weight="bold">
              {title}
            </Typography>
          )}
        </TitleContainer>

        <Typography category="body" size="small" weight="regular" color="body">
          {subtitle}
        </Typography>
      </HeaderWrapper>
      

      <Button
        iconRight="plus"
        label="Assign role"
        size="medium"
        onClick={onAssignClick}
      />
    </HeaderContainer>
  );
};

export default Header;

